import type { JSX } from "react";

import { Flex, Paper, Skeleton, Stack, Text } from "@mantine/core";

import { UpdatedTime } from "./UpdatedTime";

interface MetricCardProps {
    isError: boolean;
    isLoading: boolean;
    header: string;
    body: string;
    updatedTime?: string;
}

export function MetricCard({ isError, isLoading, header, body, updatedTime }: MetricCardProps) {
    if (isError) return <MetricCardContent header="Could not load" body={body} updatedTime="Never" />;
    if (isLoading) return <MetricCardContent header={<Skeleton h="xl" />} body={<Skeleton h="md" />} updatedTime="" />;

    return <MetricCardContent header={header} body={body} updatedTime={updatedTime} />;
}

interface MetricCardContentProps {
    header: string | JSX.Element;
    body: string | JSX.Element;
    updatedTime?: string;
}

function MetricCardContent({ header, body, updatedTime }: MetricCardContentProps) {
    return (
        <Paper w="12.5rem" p=".875rem">
            <Stack gap="xxs">
                <Text component="div" fw={700} size="lg">
                    {header}
                </Text>
                <Text component="div" size="sm">
                    {body}
                </Text>
                <Flex c="dark.2">
                    <Flex fz="xxs">
                        <UpdatedTime updatedTime={updatedTime} />
                    </Flex>
                </Flex>
            </Stack>
        </Paper>
    );
}
